import { useEffect, useState } from 'react'
import { Loader, NVButton } from '@nv/basic-components'
import { useConfigurationContext } from '@nv/contexts'
import { RegisterComputerIcon } from '@nv/images/design/register-computer-icon'
import { DateTime } from 'luxon'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './Registration.module.scss'
import '@djthoms/pretty-checkbox'

export const Registration = ({ targetDate, contactInfo, title }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { includeLoginButtonRegistrationPage } = useConfigurationContext()
  const [countdown, setCountdown] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 })
  const [isTimeToRegister, setIsTimeToRegister] = useState(false)
  const [loading, setLoading] = useState(true)
  // 10 am calgary time , noon toronto time
  const closeDate = new Date('Oct 20 2026 12:00:00 GMT-0400 (Eastern Daylight Time)')

  useEffect(() => {
    const interval = setInterval(() => {
      const now = DateTime.now()
      const diff = targetDate.diff(now, ['days', 'hours', 'minutes', 'seconds']).toObject()

      if (diff.days <= 0 && diff.hours <= 0 && diff.minutes <= 0 && diff.seconds <= 0) {
        clearInterval(interval)
        setIsTimeToRegister(true)
        setLoading(false)
      } else {
        setCountdown({
          days: Math.max(0, diff.days),
          hours: Math.max(0, diff.hours),
          minutes: Math.max(0, diff.minutes),
          seconds: Math.max(0, Math.floor(diff.seconds)),
        })
        setLoading(false)
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  useEffect(() => {
    sessionStorage.clear()
  }, [])

  if (loading) return <Loader />

  return (
    <div className={styles['container']}>
      {title}
      <div className={styles['register']}>
        <div className={styles['title']}>{t('registration.howToRegister')}</div>
        <div className={styles['content']}>
          {/* TODO format and display correct date */}
          {t('registration.onlineRegistrationRequirements', { registrationOpensDate: new Date(targetDate) })}
          <RegisterComputerIcon className={styles['img']} />
        </div>

        {isTimeToRegister ? (
          <div className={styles['buttons']}>
            {new Date() <= closeDate ? (
              <NVButton text={t('registration.registerNow')} height={50} onClick={() => navigate('/registration/step1')} />
            ) : null}

            {includeLoginButtonRegistrationPage && (
              <NVButton text={t('buttons.login')} height={50} onClick={() => navigate('/voting/voter/login')} />
            )}
          </div>
        ) : (
          <div className={styles['countdown']}>
            <div className={styles['title-s']}>{t('registration.registrationOpen')}</div>
            <div className={styles['timer']}>
              <div className={styles['time-block']}>
                <span className={styles['number']}>{String(countdown.days).padStart(2, '0')}</span>
                <span className={styles['label']}>{t('countdown.time.long.days')}</span>
              </div>
              <div className={styles['time-block']}>
                <span className={styles['number']}>{String(countdown.hours).padStart(2, '0')}</span>
                <span className={styles['label']}>{t('countdown.time.long.hours')}</span>
              </div>
              <div className={styles['time-block']}>
                <span className={styles['number']}>{String(countdown.minutes).padStart(2, '0')}</span>
                <span className={styles['label']}>{t('countdown.time.long.mins')}</span>
              </div>
              <div className={styles['time-block']}>
                <span className={styles['number']}>{String(countdown.seconds).padStart(2, '0')}</span>
                <span className={styles['label']}>{t('countdown.time.long.sec')}</span>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={styles['help']}>{contactInfo}</div>
    </div>
  )
}
